module.exports = {"id":"206565","name":"Jamie Walker","rating":"71","photo":"./data/images/photos/1/206565.png","club":{"name":"Wigan Athletic","logo":"./data/images/clubs/WiganAthletic.png"},"positions":["MOC","MG","MD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JamieWalker0.json
// module id = 1910
// module chunks = 0